import { memo, useCallback, useContext } from 'react'
import { Autocomplete, InstantSearch } from 'react-instantsearch'
import type { VariantHit } from './algolia'
import { mainIndex, searchClient } from './algoliaSearchConfig'
import { AutocompletePanelLayout } from './AutocompletePanel'
import { SearchbarPanelContext } from './SearchBarPanelContext'
// import { ALGOLIA_COOKIE_DURATION } from './searchbarQueries'
import { useSearchParams } from '../sections/AddedToCart/utils/utils'
import InsightsConsentEnabler from './InsightsConsentEnabler'
import { customFormatSearchPath } from './utils'
// Dati del panel (promo/topic/typing) fuori dallo Shell
// così InstantSearch/Autocomplete non si rimontano a ogni fetch o Cancella

const AutocompletePanelFromContext = ({ isOpen }: { isOpen: boolean }) => {
  const panel = useContext(SearchbarPanelContext)

  if (!panel) return null

  return <AutocompletePanelLayout {...panel} isOpen={isOpen} />
}

const EmptyIndexSlot = () => <></>

const autocompleteIndices = [
  {
    indexName: mainIndex,
    getQuery: (item: VariantHit) => item.productName,
    getURL: (item: VariantHit) => item.variant_url,
    headerComponent: EmptyIndexSlot,
    itemComponent: EmptyIndexSlot,
  },
]

const getSearchPageURL = (uiState: { query?: string }) =>
  customFormatSearchPath(uiState.query ?? '')

// Shell UI Algolia: input + panel
const AutocompleteShell = ({ isOpen }: { isOpen: boolean }) => {
  const { q } = useSearchParams() || {}
  const panelComponent = useCallback(
    () => <AutocompletePanelFromContext isOpen={isOpen} />,
    [isOpen]
  )

  return (
    <InstantSearch
      searchClient={searchClient}
      indexName={mainIndex}
      key={q ?? ''}
      // insights={true}
      initialUiState={{ [mainIndex]: { query: q ?? '' } }}
      // insights={{
      //   insightsInitParams: {
      //     apiKey: process.env.GATSBY_ALGOLIA_API_KEY ?? '',
      //     appId: process.env.GATSBY_ALGOLIA_APP_ID ?? '',
      //     useCookie: false,
      //     userHasOptedOut: true,
      //     // cookieDuration: ALGOLIA_COOKIE_DURATION,
      //   },
      // }}
    >
      <InsightsConsentEnabler />
      <Autocomplete
        placeholder="Cerca in Arcaplanet..."
        detachedMediaQuery="" // This disable detachedMediaQuery
        getSearchPageURL={getSearchPageURL}
        // searchParameters={{
        //   hitsPerPage: ITEMS_PER_PAGE,
        // }}
        panelComponent={panelComponent}
        classNames={{
          root: 'w-full max-w-full font-fira',
          form: `border-2 border-solid border-black flex items-center w-full max-w-full bg-white overflow-hidden ${
            isOpen ? 'rounded-t-2xl rounded-b-none border-b-0' : 'rounded-full'
          }`,
          inputWrapperPrefix: 'shrink-0 pl-3 md:pl-4',
          submitButton:
            'flex items-center justify-center bg-transparent border-0 p-0 w-5 h-5 shrink-0',
          submitButtonIcon: 'w-5 h-5 max-w-5 max-h-5 text-[#999] block',
          label: 'm-0 flex items-center shrink-0',
          inputWrapper: 'flex-1 min-w-0',
          input:
            'w-full min-w-0 bg-transparent px-2 md:px-3 py-[12px] md:py-[15px] text-[#232323] text-[15px] tracking-[0.035px] font-normal placeholder:font-normal placeholder:text-[#75777D] focus:outline-none [&::-webkit-search-cancel-button]:hidden [&::-ms-clear]:hidden',
          inputWrapperSuffix: 'flex items-center shrink-0 pr-2 md:pr-3',
          resetButton: `[&:not([hidden])]:flex items-center gap-1 md:gap-2 border-0 bg-transparent cursor-pointer p-0 text-xs md:text-sm text-[#75777d] before:content-['Cancella'] font-semibold ${
            isOpen ? '' : '!hidden'
          }`,
          resetButtonIcon: `w-6 h-6 md:w-6 md:h-6 p-1 box-content rounded-full bg-[#ececec] text-[#666] shrink-0 ${
            isOpen ? '' : '!hidden'
          }`,
          loadingIndicator: 'hidden',
          panel: `absolute overflow-y-auto max-h-[520px] md:max-h-[450px] w-full p-5 md:px-8 md:py-6 bg-white scrollbar-thin z-[60] [&[hidden]]:hidden ${
            isOpen
              ? 'mt-0 rounded-t-none rounded-b-2xl border-2 border-solid border-black border-t-0 shadow-[0_8px_24px_rgba(0,0,0,0.18)]'
              : '!hidden'
          }`,
        }}
        indices={autocompleteIndices}
      />
    </InstantSearch>
  )
}

export default memo(AutocompleteShell)
